import { Component, EventEmitter, Output } from '@angular/core';
import { DebouncedFunc, isEmpty, throttle } from 'lodash';
import { IDevice } from '@internal-models/device.model';
import { FormControl } from '@angular/forms';
import { IClient } from '@internal-models/client.model';
import { ClientProvider } from '@internal-providers/client.provider';

@Component({
	selector: 'search-client',
	templateUrl: 'search-client.component.html',
	styleUrls: ['./search-client.component.scss'],
})
export class SearchClientComponent {
	@Output() selected: EventEmitter<IClient> = new EventEmitter();

	public loading: boolean = false;
	public error: boolean = false;
	public currentSearch: object = {};
	public searchResults: Array<IClient> = new Array();
	public selectedClientOrPartner: string;
	public searchLoanForm: FormControl;
	public inLoanDevices: Array<IDevice> = [];
	private throttledSearch: DebouncedFunc<(scope: SearchClientComponent, search: object) => void>;

	constructor(private readonly provider: ClientProvider) {
		this.addResetSearchEventListeners();
	}

	public autocomplete(search: { [key: string]: string }): void {
		this.setCurrentSearch(search);
		if (search.firstname?.length >= 1 || search.lastname?.length >= 1) {
			this.loading = true;
			if (!this.throttledSearch) {
				this.throttledSearch = throttle(
					(scope: SearchClientComponent, search: object) => {
						scope.provider
							.searchAll(search as any)
							.then((data) => {
								scope.loading = false;
								scope.error = false;
								scope.searchResults = data;
							})
							.catch(() => () => {
								scope.loading = false;
								scope.error = true;
							});
					},
					1000,
					{ trailing: true }
				);
			}
			this.throttledSearch(this, this.currentSearch);
		} else this.resetSearch();
	}

	public onClientSelected(client: IClient): void {
		this.selected.emit(client);
		this.resetSearch();
		this.throttledSearch.cancel();
	}

	private resetSearch(): void {
		this.searchResults = new Array();

		const firstnameInput = document.getElementById('firstname-input') as HTMLInputElement;
		const lastnameInput = document.getElementById('lastname-input') as HTMLInputElement;

		if (firstnameInput) {
			firstnameInput.value = '';
		}

		if (lastnameInput) {
			lastnameInput.value = '';
		}
	}

	public addResetSearchEventListeners(): void {
		document.addEventListener('keydown', (event: KeyboardEvent) => {
			if (
				event.key === 'Escape' ||
				event.key === 'Esc' ||
				event.keyCode === 27 ||
				event.key === 'Tab' ||
				event.keyCode === 9
			) {
				this.resetSearch();
			}
		});
		document.addEventListener('click', (event) => {
			if ((event.target as HTMLElement).className !== '_search-result') {
				this.resetSearch();
			}
		});
	}

	private setCurrentSearch(search: { [key: string]: string }): void {
		Object.keys(this.currentSearch).forEach((key) => {
			if (isEmpty(this.currentSearch[key])) {
				delete this.currentSearch[key];
			}
		});
		this.currentSearch = { ...this.currentSearch, ...search };
	}
}
